/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reaction: NonNullable<unknown>, count: NonNullable<unknown> }} Clubs_Reaction_LabelInputs */

const en_us2_clubs_reaction_label = /** @type {(inputs: Clubs_Reaction_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.reaction}: ${i?.count}`)
};

const pt_br2_clubs_reaction_label = /** @type {(inputs: Clubs_Reaction_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.reaction}: ${i?.count}`)
};

const es_419_clubs_reaction_label = /** @type {(inputs: Clubs_Reaction_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.reaction}: ${i?.count}`)
};

const pt_pt2_clubs_reaction_label = /** @type {(inputs: Clubs_Reaction_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.reaction}: ${i?.count}`)
};

const fr_fr2_clubs_reaction_label = /** @type {(inputs: Clubs_Reaction_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.reaction} : ${i?.count}`)
};

const de_de2_clubs_reaction_label = /** @type {(inputs: Clubs_Reaction_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.reaction}: ${i?.count}`)
};

const it_it2_clubs_reaction_label = /** @type {(inputs: Clubs_Reaction_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.reaction}: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "{reaction}: {count}" |
*
* @param {Clubs_Reaction_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_reaction_label = /** @type {((inputs: Clubs_Reaction_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Reaction_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_reaction_label(inputs)
	if (locale === "es-419") return es_419_clubs_reaction_label(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_reaction_label(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_reaction_label(inputs)
	if (locale === "de-DE") return de_de2_clubs_reaction_label(inputs)
	if (locale === "it-IT") return it_it2_clubs_reaction_label(inputs)
	return en_us2_clubs_reaction_label(inputs)
});
export { clubs_reaction_label as "clubs.reaction_label" }